if (!customElements.get('upgrade-add-modal')) {
  customElements.define(
    'upgrade-add-modal',
    class UpgradeAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="UpgradeAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        if (preventFocus) {
          this.modalContent.innerHTML = '';
          this.openedBy = null;
          super.hide();
        }
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('div[id^="MainProduct-"]');
            this.productInfo = this.productElement.querySelector('product-info');
            this.upgrades = this.productElement.querySelectorAll('.upgrade-product');

            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            
            this.upgrades.forEach((upgrade) => {
              this.getDeviceCard(upgrade);
            })

            this.getDeviceCard(this.productInfo);
            this.toggleDetails();
            super.show(opener);

            window.addEventListener('resize', this.onResize);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
      }

      getDeviceCard(element) {
        const wrapper = document.createElement('div');

        if (element.classList.contains('upgrade-product')) {
          const mediaGallery = element.querySelector('.card-media');
          wrapper.append(mediaGallery);
          wrapper.classList.add('upgrade-product');
        } else {
          const mediaGallery = this.productElement.querySelector('[id^="Slider-Gallery-"]');
          const mediaImages = mediaGallery.querySelectorAll('[id^="Slide-template-"]');

          if (mediaImages) {
            const featured_media = [...mediaImages].find((media) => {
              if (media.querySelectorAll('.media-type-image').length !== 0) {
                media.querySelector('.product__media').classList.add('media--transparent');
                return media;
              }
            });
            wrapper.append(featured_media.querySelector('.product__media'));
          }
          wrapper.classList.add('device-product');
          wrapper.classList.add('color-scheme-2');
        }
        
        const productTitle = element.querySelector('.product__title');
        if (productTitle) {
          productTitle.classList.add('center');
          wrapper.append(productTitle);
        }

        const cardPrice = element.querySelector('.price');
        if (cardPrice) wrapper.append(cardPrice);

        if (!element.classList.contains('upgrade-product')) {
          const mainSubmit = element.querySelector('[id^="ProductSubmitButton-"]');
          mainSubmit.classList.add('color-scheme-6');
          mainSubmit.classList.remove('button--secondary');
          mainSubmit.removeAttribute('data-modal');

          trapFocus(this.modalContent, mainSubmit);

        } else {
          const ribbon = element.querySelector('.savings');
          if(ribbon) wrapper.append(ribbon);

          const details = element.querySelector('details');

          if(details) wrapper.append(details);
        }
        
        const mainForm = element.querySelector('product-form');
        wrapper.append(mainForm);

        this.modalContent.append(wrapper);
      }

      toggleDetails() {
        const modalCoordinates = this.modalContent.getBoundingClientRect();
        console.log(modalCoordinates.height, modalCoordinates.width);

        this.modalContent.querySelectorAll('details').forEach((detail) => {
          //orientation landscape
          if (modalCoordinates.width > modalCoordinates.height) {
            if (modalCoordinates.height > 550) {
              detail.setAttribute('open', '');
            } else {
              detail.removeAttribute('open');
            }
          } 
          //orientation portrait
          else {
            if(modalCoordinates.height > 740){
              detail.setAttribute('open', '');
            } else {
              detail.removeAttribute('open');
            }

            if(window.innerWidth > 767 && window.innerWidth < 820) {
              detail.removeAttribute('open');

            }
          }
        });
      }


      onResize = () => {
        this.toggleDetails();
      }
    }
  );
}
